import { useLazyQuery, useMutation } from '@apollo/client';
import {
  AuthenticatedUser,
  GET_USER_DATA,
  mapToUserFront,
  ResponseApolloErrorMapping,
  UserAction,
  UserContext,
  UserStatus,
} from '@contexts/Shared';
import { useContext, useEffect, useState } from 'react';

import {
  mapUpdateTenantInformationDomainToDto,
  UpdateTenantInformationRequestDto,
  UpdateTenantInformationResponseDto,
} from '../dtos';
import { updateTenantInformation } from '../schemas';
import {
  TenantInformationCommandActions,
  UpdateTenantInformationT,
} from './../../../domain';
import { UpdateTenantInformationCommand } from './../../../domain/commands/update-tenant-information.command';

export const GqlTenantInformationCommandActions: TenantInformationCommandActions =
  {
    useUpdateTenantInformation: (): UpdateTenantInformationT => {
      const [
        action,
        { data: editUserInfoData, loading, error: errorEditTenant },
      ] = useMutation<
        UpdateTenantInformationResponseDto,
        UpdateTenantInformationRequestDto
      >(updateTenantInformation);
      const [
        getAuthenticatedUser,
        { data: dataAuthUser, loading: loadingAuthUser },
      ] = useLazyQuery<{
        getAuthenticatedUser: AuthenticatedUser;
      }>(GET_USER_DATA, { errorPolicy: 'all', fetchPolicy: 'no-cache' });
      const user = useContext(UserContext);
      const [userData, setUserData] = useState<AuthenticatedUser | null>(null);

      useEffect(() => {
        if (editUserInfoData && editUserInfoData.updateUserInfo?.value) {
          getAuthenticatedUser();
        }
      }, [editUserInfoData]);

      useEffect(() => {
        if (user && dataAuthUser && dataAuthUser.getAuthenticatedUser) {
          user.dispatch({
            type: UserAction.USER_FETCH_DATA_UPDATE,
            payload: {
              data: mapToUserFront(dataAuthUser.getAuthenticatedUser),
              status: UserStatus.IS_LOGGED_IN,
            },
          });
        }
      }, [dataAuthUser]);

      return {
        dataAuthUser: dataAuthUser?.getAuthenticatedUser,
        loading: loadingAuthUser || loading,
        error: errorEditTenant && ResponseApolloErrorMapping(errorEditTenant),
        updatedTenantInformation: editUserInfoData?.updateUserInfo.value,
        updateTenantInformation: (data: UpdateTenantInformationCommand) => {
          setUserData(mapToUserFront(data.editUserInfoData));
          action({
            variables: mapUpdateTenantInformationDomainToDto(
              data.editUserInfoData
            ),
          });
        },
      };
    },
  };
